import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { styled, StyleSheet, border } from '@rexlabs/styling';
import { useDownshiftContext, MENU_STATES } from '../../../core';
import DefaultLoading from './loading';
import DefaultError from './error';
import DefaultHelper from './helper';
import DefaultNoResultsFound from './no-results-found';
var defaultStyles = StyleSheet({
  container: _objectSpread(_objectSpread({
    overflow: 'auto',
    maxHeight: '200px'
  }, border.styles({
    target: 'select.menu',
    all: {
      radius: 'l'
    }
  })), {}, {
    backgroundColor: function backgroundColor(_ref) {
      var token = _ref.token;
      return token('select.menuContainer.background.color', token('color.container.static.default'));
    },
    boxShadow: function boxShadow(_ref2) {
      var token = _ref2.token;
      return token('select.menuContainer.shadow', token('shadow.medium'));
    }
  })
});

function MenuContent(_ref3) {
  var s = _ref3.styles,
      children = _ref3.children,
      _ref3$Helper = _ref3.Helper,
      Helper = _ref3$Helper === void 0 ? DefaultHelper : _ref3$Helper,
      _ref3$Loading = _ref3.Loading,
      Loading = _ref3$Loading === void 0 ? DefaultLoading : _ref3$Loading,
      _ref3$Error = _ref3.Error,
      Error = _ref3$Error === void 0 ? DefaultError : _ref3$Error,
      _ref3$NoResultsFound = _ref3.NoResultsFound,
      NoResultsFound = _ref3$NoResultsFound === void 0 ? DefaultNoResultsFound : _ref3$NoResultsFound;

  var _useDownshiftContext = useDownshiftContext(),
      menuState = _useDownshiftContext.menuState;

  var content = null;

  switch (menuState) {
    case MENU_STATES.LOADING:
      content = /*#__PURE__*/React.createElement(Loading, null);
      break;

    case MENU_STATES.ERROR:
      content = /*#__PURE__*/React.createElement(Error, null);
      break;

    case MENU_STATES.HELPER:
      content = /*#__PURE__*/React.createElement(Helper, null);
      break;

    case MENU_STATES.NO_RESULTS_FOUND:
      content = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(NoResultsFound, null), children);
      break;

    default:
      content = children;
  }

  return /*#__PURE__*/React.createElement("div", s('container'), content);
}

export default styled(defaultStyles)(MenuContent);